import { generateMetricKey } from '@intelligence/v3/utils/metric';
import { DATASOURCE_KEY_MAP, NEWZOO_METRIC_KEY_MAP } from './keyMap';

/**
 * Newzoo数据源Total Revenue指标
 */
export const NEWZOO_TOTAL_REVENUE_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.NEWZOO,
  metric: NEWZOO_METRIC_KEY_MAP.TOTAL_REVENUE,
});

/**
 * Newzoo数据源Total Players指标
 */
export const NEWZOO_TOTAL_PLAYERS_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.NEWZOO,
  metric: NEWZOO_METRIC_KEY_MAP.TOTAL_PLAYERS,
});
